import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=1b83f306&"
import script from "./ReadOnly.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReadOnly.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports